import * as React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import Layout from '../AdminClient/Layout';
import Profile from 'pages/shared/Profile';
import { AdminClientHomePage } from 'pages/AdminClient/Homepage';
import CreateProject from 'pages/AdminClient/CreateProject';
import CreateWebsiteAdminClient from 'pages/AdminClient/CreateWebsite';
import ClientAdminUsersManagement from 'pages/AdminClient/ClientAdminUsersManagement';
import Support from 'pages/AdminClient/Support';
import Subscription from 'pages/AdminClient/Subscription';
import Forfait from 'pages/AdminClient/Forfait';
import InProgressProjects from 'pages/AdminClient/InProgressProjects';
import NonAttributedProjects from 'pages/AdminClient/NonAttributedProjects';
import SmartProjects from 'pages/AdminClient/SmartProjects';
import DelayedProjects from 'pages/AdminClient/DelayedProjects';
import ValidatedProjects from 'pages/AdminClient/ValidatedProjects';
import SmartWithReviewProjects from 'pages/AdminClient/SmartWithReviewProjects';
import ProjectDisplay from 'pages/AdminClient/ProjectDisplay';

import AdminClientTextDisplay from 'pages/AdminClient/AdminClientTextDisplay';
import AssignedTraductionText from 'pages/AdminClient/assignedtraductiontext';
import IASmartPage from 'pages/AdminClient/RedactionIA/AISmartcontent';
import BriefGenerator from 'pages/AdminClient/RedactionIA/BriefGenerator';
import CreateIASmartText from 'pages/AdminClient/RedactionIA/createIAsmarttext';
import CreateIAbrief from 'pages/AdminClient/RedactionIA/createIAbrief';
import AgentIaList from 'pages/AdminClient/AgentIaList';
import CreateCustomAIAgentForm from 'pages/AdminClient/CreateAgentIA';
import CreateCustomAIAgentFormTranslation from 'pages/AdminClient/CreateAgentIATranslation';
import CreateAgentIAFromList from 'pages/AdminClient/createagentiafromlist';
import TraductionIaList from 'components/shared/traductionIa/traductionIalist';
import CreateTraductionIA from 'components/shared/traductionIa/createtraductionIA';
import Listofwebsitetexts from 'pages/AdminClient/Listofwebsitetexts';
import KeywordDiscovery from 'pages/AdminClient/KeywordDiscovery';
import GenerateKeyword from 'pages/AdminClient/GenerateKeyword';

export default class AdminClientMainMenu extends React.Component {
  render() {
    return (
      <Layout>
        <Switch>
          <Route
            path="/AdminClient/AdminMainMenu"
            render={(props) => <AdminClientHomePage {...props} reload={true} />}
          />
          <Route path="/AdminClient/KeywordDiscovery" component={KeywordDiscovery} />
          <Route path="/AdminClient/GenerateKeyword" component={GenerateKeyword} />
          <Route path="/AdminClient/IA_Smart" component={IASmartPage} />
          <Route path="/AdminClient/createIAsmarttext" exact component={CreateIASmartText} />
          <Route path="/AdminClient/createIAsmarttext/:id" component={CreateIASmartText} />
          <Route path="/AdminClient/createIAbrief" exact component={CreateIAbrief} />
          <Route path="/AdminClient/createIAbrief/:id" component={CreateIAbrief} />
          <Route path="/AdminClient/BriefGenerator" component={BriefGenerator} />
          <Route path="/AdminClient/MonProfil" component={Profile} />
          <Route path="/AdminClient/CreateProject" component={CreateProject} />
          <Route path="/AdminClient/AgentIAList" component={AgentIaList} />
          <Route path="/AdminClient/AgentIA" component={CreateCustomAIAgentForm} />
          <Route path="/AdminClient/createagentiafromlist" exact component={CreateAgentIAFromList} />
          <Route path="/AdminClient/createagentiafromlist/:agentId" component={CreateAgentIAFromList} />
          <Route path="/AdminClient/CreateAgentIA/:agentId" component={CreateAgentIAFromList} />
          <Route path="/AdminClient/AgentIATraduction/:agentId" component={CreateCustomAIAgentFormTranslation} />
          <Route path="/AdminClient/TraductionIA" component={TraductionIaList} />
          <Route
            path="/AdminClient/IA_Smart_GMB"
            render={(props) => <IASmartPage {...props} presetType="GMB" />}
          />
          <Route
            path="/AdminClient/IA_Smart_Store_Locator"
            render={(props) => <IASmartPage {...props} presetType="STORE_LOCATOR" />}
          />
          <Route
            path="/AdminClient/IA_Smart_Category"
            render={(props) => <IASmartPage {...props} presetType="LONG_CATEGORY" />}
          />
          <Route path="/AdminClient/CreateTraductionIA" exact component={CreateTraductionIA} />
          <Route path="/AdminClient/CreateTraductionIA/:id" component={CreateTraductionIA} />
          <Route
            path="/AdminClient/IA_Smart_OPT"
            render={(props) => <IASmartPage {...props} presetType="CONTENT_IMPROVEMENT" />}
          />
          <Route
            path="/AdminClient/AjouterSiteWeb"
            component={CreateWebsiteAdminClient}
          />
          <Route path="/AdminClient/ficheClientWeb" component={CreateWebsiteAdminClient} />
          <Route
            path="/AdminClient/ProjectsValides"
            component={ValidatedProjects}
          />
          <Route
            path="/AdminClient/ProjectsEnRetard"
            component={DelayedProjects}
          />
          <Route
            path="/AdminClient/ProjectsEnCours"
            component={InProgressProjects}
          />
          <Route
            path="/AdminClient/ProjectsNonAttribuees"
            component={NonAttributedProjects}
          />
          <Route
            path="/AdminClient/ProjectsIntelligentes"
            component={SmartProjects}
          />
          <Route
            path="/AdminClient/ProjectsReview"
            component={SmartWithReviewProjects}
          />
          <Route
            path="/AdminClient/GestionUtilisateur"
            component={ClientAdminUsersManagement}
          />
          <Route
            path="/AdminClient/Support"
            component={Support}
          />
          <Route
            path="/AdminClient/Forfait"
            component={Forfait}
          />
          <Route
            path="/AdminClient/Abonnement"
            component={Subscription}
          />
          <Route path="/AdminClient/DetailsProject" component={ProjectDisplay} />
          <Route
            path="/AdminClient/TextDetails"
            exact
            component={AdminClientTextDisplay}
          />
          <Route
            path="/AdminClient/TextDetails/:id"
            component={AdminClientTextDisplay}
          />
          <Route
            path="/AdminClient/assignedtraductiontext"
            component={AssignedTraductionText}
          />
          <Route path="/AdminClient/Listofwebsitetexts" component={Listofwebsitetexts} />
          <Route path="*">
            <Redirect to="/AdminClient/AdminMainMenu" />
          </Route>
        </Switch>
      </Layout>
    );
  }
}
